/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12.949 2.93a5.75 5.75 0 018.13 8.131l-.009.01-3 3a5.75 5.75 0 01-8.67-.622.75.75 0 011.2-.898 4.25 4.25 0 006.41.459l2.995-2.996a4.25 4.25 0 00-6.01-6.008l-1.716 1.706a.75.75 0 11-1.058-1.064l1.728-1.717zM7.986 8.607a5.75 5.75 0 016.615 1.944.75.75 0 01-1.202.898 4.251 4.251 0 00-6.409-.459l-2.995 2.995a4.25 4.25 0 006.01 6.01l1.705-1.705a.75.75 0 011.06 1.06l-1.719 1.72a5.75 5.75 0 01-8.13-8.131l.009-.01 3-3a5.75 5.75 0 012.056-1.322z'
      />
    </svg>
  );
}

export default SvgLink;
